export const CONFIG_KEY_ACTIVE_AI = 'config_setting_active_ai';
/** Skill AI gợi ý bước B1–B5 trong bubble chat */
export const CONFIG_KEY_AI_STEP_SUGGEST = 'config_setting_ai_step_suggest';

/** Legacy: inject `public/toppion-embed.js` thay vì Hub React (chỉ khi bật env). */
export const AI_LEGACY_EMBED = process.env.NEXT_PUBLIC_AI_LEGACY_EMBED === '1';
